"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validatePhoneNumber = exports.formatMoney = exports.addThousandSeparator = exports.capitalizeFirstLetter = exports.toOrdinalSuffix = exports.urlToFile = exports.isObjectEmpty = exports.capitalize = exports.arrayMove = exports.formatDate = exports.getLocalISODate = exports.getISODate = exports.isDevMode = exports.isValidData = void 0;
var axios_1 = __importDefault(require("axios"));
var moment_1 = __importDefault(require("moment"));
// import { redux_store } from "../store";
// import { API_URL } from "./service_urls";
function isValidData(e) {
    if (!e.data ||
        e.data.target == "onboardingcomplete" ||
        e.data.target == "inpage" ||
        e.data.type == "INIT_INSTANCE" ||
        e.data.type == "webpackOk" ||
        e.data.type == "webpackStillOk" ||
        (e.data.source &&
            (e.data.source == "react-devtools-bridge" ||
                e.data.source == "react-devtools-inject-backend" ||
                e.data.source == "react-devtools-content-script" ||
                e.data.source == "react-devtools-detector"))) {
        return false;
    }
    return true;
}
exports.isValidData = isValidData;
function isDevMode() {
    return process.env.NODE_ENV == "development";
}
exports.isDevMode = isDevMode;
function getISODate(date) {
    if (date) {
        return (0, moment_1.default)(date).toISOString(true);
    }
    else {
        return (0, moment_1.default)().toISOString(true);
    }
}
exports.getISODate = getISODate;
function getLocalISODate(date) {
    if (date) {
        return (0, moment_1.default)(date).local().toISOString(true);
    }
    else {
        return "";
    }
}
exports.getLocalISODate = getLocalISODate;
function formatDate(date, format) {
    if (format === void 0) { format = "Do MMM YYYY, h:mm A"; }
    if (date) {
        return (0, moment_1.default)(getLocalISODate(date)).format(format);
    }
    else {
        return "";
    }
}
exports.formatDate = formatDate;
function arrayMove(arr, fromIndex, toIndex) {
    console.log("fromIndex", fromIndex);
    console.log("toIndex", toIndex);
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
    console.log("arr", arr);
}
exports.arrayMove = arrayMove;
function capitalize(s) {
    if (typeof s !== "string")
        return "";
    return s.charAt(0).toUpperCase() + s.slice(1);
}
exports.capitalize = capitalize;
function isObjectEmpty(object) {
    for (var property in object) {
        return false;
    }
    return true;
}
exports.isObjectEmpty = isObjectEmpty;
function urlToFile(url) {
    return __awaiter(this, void 0, void 0, function () {
        var fileName, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    fileName = url.split("/").pop();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios_1.default.get(url, {
                            responseType: "blob",
                        })];
                case 2:
                    response = _a.sent();
                    return [2 /*return*/, new File([response.data], fileName)];
                case 3:
                    error_1 = _a.sent();
                    // empty file
                    return [2 /*return*/, new File([], fileName)];
                case 4: return [2 /*return*/];
            }
        });
    });
}
exports.urlToFile = urlToFile;
function toOrdinalSuffix(i) {
    var j = i % 10, k = i % 100;
    if (j == 1 && k != 11) {
        return i + "st";
    }
    if (j == 2 && k != 12) {
        return i + "nd";
    }
    if (j == 3 && k != 13) {
        return i + "rd";
    }
    return i + "th";
}
exports.toOrdinalSuffix = toOrdinalSuffix;
var capitalizeFirstLetter = function (string) {
    if (string === void 0) { string = ""; }
    return string.charAt(0).toUpperCase() + string.slice(1);
};
exports.capitalizeFirstLetter = capitalizeFirstLetter;
var addThousandSeparator = function (value) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
};
exports.addThousandSeparator = addThousandSeparator;
var formatMoney = function (decimal) {
    decimal = parseFloat(decimal).toFixed(2);
    return "R".concat((0, exports.addThousandSeparator)(decimal));
};
exports.formatMoney = formatMoney;
var validatePhoneNumber = function (value) {
    var regex = RegExp(/^(\+?\d{1,3})?[0-9]{10}$/);
    return regex.test(value);
};
exports.validatePhoneNumber = validatePhoneNumber;
